import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';

// Old links used hash routes (imuslimlife.com/#/quran, /#/mobile-app#screenshots).
// Move them to the real URL before the router starts, keeping any section hash.
if (window.location.hash.startsWith('#/')) {
  const [route, section] = window.location.hash.slice(1).split('#');
  // Pages are folders on GitHub Pages, so /alexa-skill becomes /alexa-skill/ (matches the canonical).
  const [path, query] = route.split('?');
  const url = (path.endsWith('/') ? path : `${path}/`) + (query ? `?${query}` : '');
  window.history.replaceState(null, '', url + (section ? `#${section}` : ''));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker for offline functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered: ', registration);
      })
      .catch(registrationError => {
        console.log('Service Worker registration failed: ', registrationError);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();